import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationsService } from '@nx-ratenow/shared/data-access-utils';
import { forkJoin, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import * as NotificationActions from './notifications.actions';

@Injectable()
export class NotificationsEffects {
  // GET NOTIS

  getingNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.getNotifications),
      switchMap(() => {
        return forkJoin([this.notificationService.getNotification(), this.notificationService.getNotificationScheduled()]).pipe(
          map(([personalNotificaitons, scheludedNotifications]) =>
            NotificationActions.setNotifications({
              personalNotificaitons,
              scheludedNotifications
            })
          )
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationsService
  ) {}
}
